import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axiosCAPApiPrivate from "../api/axiosCAPApiPrivate";

const ApprovalConfirmation = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("SessionId");
  const emailShipper = searchParams.get("Email");
  const bookingNo = searchParams.get("BookingNo");
  const [loading, setLoading] = useState(true);
  const [approved, setApproved] = useState(false);
  const [error, setError] = useState(null);
  const [toastKind, setToastKind] = React.useState("");
  const [toastTitle, setToastTitle] = React.useState("");
  const [toastDesc, setToastDesc] = React.useState("");

  React.useEffect(() => {
    const onSaveOrder = async () => {
        setLoading(true);
        console.log("BulkId:", sessionId);

        try {
            const response = await axiosCAPApiPrivate.post(
                "/api/ApproveBySessionId",
                { BulkSessionId: Number(sessionId) }
            );
            const resData = response.data;
            if (resData.Code === "200") {
                console.log("Booking Success:", resData);
                sendEmailToShipper();
                setApproved(true);
            } else {
                console.warn("Booking Failed:", resData);
                setToastKind("error");
                setToastTitle("Booking Failed");
                setToastDesc(resData.Message || "Something went wrong.");
            }
        } catch (error) {
            console.error("API Error:", error.response?.data || error.message);
            setToastKind("error");
            setToastTitle("API Fetch Failed!");
            setToastDesc(error.message);
        } finally {
            setLoading(false);
        }
    };

    const sendEmailToShipper = async () => {
      const emailBody = `Request has been approved, Please wait for the confirmation of your order with ref no: ${bookingNo}`;
      try {
        const response = await axiosCAPApiPrivate.post("/api/SendEmail", {
          fromEmail: "noreply-app1@lbcmail.com",
          // fromEmail: "Customercare@lbcexpress.com",
          // toEmail: "C&C@lbcexpress.com",
          toEmail: emailShipper,
          // toEmail: "fcpalay@lbcexpress.com",
          ccEmail: "Sales_Support@lbcexpress.com,pudsupport@lbcexpress.com,CCMRelManagement@lbcexpress.com",
          // toEmail: "fcpalay@lbcexpress.com",
          // toEmail: emailShipper,
          subject: "Corporate Account's Portal: ORDER OF SENDTIPID",
          html: true,
          body: emailBody
        });
      } catch (error) {

        console.error("API Error:", error.response?.data || error.message);
        setToastKind("error");
        setToastTitle("API Fetch Failed!");
        setToastDesc(error.message);
      }
    };

    if (sessionId) {
        onSaveOrder();
        sendEmailToShipper();
    } else {
        setError("No Session ID found in URL.");
        setLoading(false);
    }
    }, [sessionId]);

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Booking Status</h2>
      {loading ? (
        <p>Checking your booking...</p>
      ) : error ? (
        <p style={{ color: "red" }}> {error}</p>
      ) : approved ? (
        <>
          <p>
            ✅ <strong>Session ID {sessionId}</strong> has been successfully
            approved.
          </p>
          <p>Thank you! The order has been marked as approved in our system.</p>
        </>
      ) : (
        <>
          <p>
            ✅ <strong>Session ID {sessionId}</strong> has been successfully
            approved.
          </p>
          <p>Thank you! The order has been marked as approved in our system.</p>
        </>
      )}
    </div>
  );
};

export default ApprovalConfirmation;